module.exports = __webpack_public_path__ + "static/media/flushed.b416bc1c.svg";